export const CREATE_SCENARIO = `
	mutation CreateSceneario($input: CreateScenarioMutationInput!) {
		createScenario(input: $input) {
			scenario {
				id
				databaseId
				name
			}
			errors {
				message
				fullMessage
				path
				type
			}
		}
	}
`;

export const RENAME_SCENARIO = `
	mutation RenameScenario($input: UpdateScenarioMutationInput!) {
		updateScenario(input: $input) {
			scenario {
				id
				databaseId
				name
			}
			errors {
				message
				fullMessage
				path
				type
			}
		}
	}
`;

export const LIST_SCENARIOS = `
	query ListScenarios($first: Int, $afterIndex: Int, $scenariosQueryArguments: ScenariosQueryInputObject) {
		scenarios(first: $first, afterIndex: $afterIndex, scenariosQueryArguments: $scenariosQueryArguments) {
			nodes {
				id
				databaseId
				name
				description
				version
				createdAt
				updatedAt
				latestRelease {
					id
					databaseId
					sdkVersion
					sceneName
					type
					version
					updatedAt
					createdAt
					publishedAt
					hasVuforia
					hasRoomScale
					hasMultiPointAlignment
					hasPreScannedAreaHolographic
					downloadUrl
					author {
						id
						databaseId
						email
						name
						firstName
						lastName
						username
						permalink
					}
				}
				originGroup {
					id
					name
				}
				organization {
					id
					databaseId
				}
				recipientGroups {
					nodes {
						id
						name
					}
				}
				permissions {
					canUpdate {
						value
					}
				}
			}
		}
	}
`;